// Danh mục cờ trạng thái giai đoạn P0 (BRANCHES §11). Cờ nằm trong `core` của save (Bất biến 8).
// M0 chỉ khai báo schema; hệ thống đặt cờ đến ở các milestone sau.

export const SPARK_IDS = [
  'defiant_heart',
  'still_light_vase',
  'devouring_body',
  'supreme_bone',
  'bronze_ring',
  'spring_autumn',
  'fate_eye',
] as const;
export type SparkId = (typeof SPARK_IDS)[number];

/** Giá trị của `main_opening_first_question` (STORY Phụ lục A6). */
export const OPENING_FIRST_QUESTION_VALUES = ['who', 'sister', 'silence'] as const;

export type FlagDef =
  | { readonly id: string; readonly kind: 'bool' }
  | { readonly id: string; readonly kind: 'int'; readonly min: number; readonly max: number }
  | { readonly id: string; readonly kind: 'enum'; readonly values: readonly string[] };

export const FLAGS_P0: readonly FlagDef[] = [
  { id: 'main_spark_choice', kind: 'enum', values: SPARK_IDS },
  // Câu hỏi đầu tiên với Đăng Linh (STORY Phụ lục A6): chỉ đổi thoại về sau.
  { id: 'main_opening_first_question', kind: 'enum', values: OPENING_FIRST_QUESTION_VALUES },
  { id: 't1_lamp_lit', kind: 'bool' },
  { id: 't1_dang_can_formed', kind: 'bool' },
  { id: 't1_writing_lessons', kind: 'int', min: 0, max: 9 },
  { id: 't4_guardian_fate', kind: 'enum', values: ['spared', 'killed'] },
  { id: 't4_guardian_channel', kind: 'enum', values: ['none', 'interrupted', 'completed'] },
  { id: 'war_village_child_saved', kind: 'bool' },
];

export type FlagValue = boolean | number | string;

/** Giá trị có hợp schema của cờ không (dùng khi hydrate / validate save). */
export function isValidFlagValue(def: FlagDef, v: unknown): v is FlagValue {
  switch (def.kind) {
    case 'bool':
      return typeof v === 'boolean';
    case 'int':
      return Number.isInteger(v) && (v as number) >= def.min && (v as number) <= def.max;
    case 'enum':
      return typeof v === 'string' && def.values.includes(v);
  }
}
